<div class="container pt-2 pb-2">
    Privacy Policy
 </div>